module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-5x"
  })]) : _c('div', [_c('va-chart', {
    attrs: {
      "chart-config": _vm.chartData
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7"
  }, [(_vm.loading_case) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-5x"
  })]) : _c('div', [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('case_summary')) + " : " + _vm._s(_vm.caseSummary.total))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-male fa-2x text-primary"
  }), _c('br'), _vm._v(_vm._s(_vm.caseSummary.male))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartCaseDataMale
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-female fa-2x text-warning"
  }), _c('br'), _vm._v(_vm._s(_vm.caseSummary.female))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartCaseDataFemale
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading_age) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-5x"
  })]) : _c('div', [_c('div', {
    staticClass: "border-top my-3",
    staticStyle: {
      "border-top": "1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('age_group_active')) + " :" + _vm._s(_vm.ageSummary.total))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-male fa-3x text-primary"
  })]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartAgeDataMale
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-female fa-3x text-warning"
  })]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartAgeDataFemale
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading_death) ? _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-5x"
  })]) : _c('div', [_c('div', {
    staticClass: "border-top my-3",
    staticStyle: {
      "border-top": "1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('age_group_death')) + " : " + _vm._s(_vm.deathSummary.total))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-male fa-2x text-primary"
  }), _c('br'), _vm._v(_vm._s(_vm.deathSummary.male))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartDeathDataMale
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('P', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-female fa-2x text-warning"
  }), _c('br'), _vm._v(_vm._s(_vm.deathSummary.female))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartDeathDataFemale
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ca9d2704!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Report-Patient.vue
// module id = 744
// module chunks = 1